export const environment_us_dev = {
  PRODUCTION: false,
  APP_ENDPOINT: 'https://app.devenv.us.printix.net',
  CHECK_SERVER_HEALTH: 'https://api.devenv.us.printix.net/manage/health',
  INTERNAL_TEST_WAIT_TIME: 'https://api.devenv.us.printix.net/internal/testing/wait/',
  INTERNAL_TEST_RETURN_SET_STATUS_CODE: 'https://api.devenv.us.printix.net/internal/testing/status/',
  ENDPOINT_API: 'https://api.devenv.us.printix.net',
  ENDPOINT_TENANT_DOMAIN: 'https://auth.devenv.us.printix.net/oauth/authorize/tenant/',
  ENDPOINT_TENANT_LESS: 'https://auth.devenv.us.printix.net/oauth/authorize',
  ENDPOINT_SIGN_IN_MS: 'https://auth.devenv.us.printix.net/identity-providers/azure/signin?redirect_uri=',
  ENDPOINT_SIGN_IN_GOOGLE: 'https://auth.devenv.us.printix.net/identity-providers/google/signin?redirect_uri=',
  ENDPOINT_AUTH_TOKENS: 'https://auth.devenv.us.printix.net/oauth/token',
  ENDPOINT_GET_TENANT_USER: 'https://api.devenv.us.printix.net/v1/users/me',
  ENDPOINT_FIND_TENANT: 'https://api.devenv.us.printix.net/v1.2/find/',
  ENDPOINT_SIGN_OUT_BROWSER: 'https://auth.devenv.us.printix.net/logout',
  ENDPOINT_SIGN_OUT_NATIVE: 'https://auth.devenv.us.printix.net/oauth/logout',
  ENDPOINT_REVOKE_TOKEN: 'https://auth.devenv.us.printix.net/oauth2/revoke',
  ENVIRONMENT_STATE: 'devenv'
};